import React, { useState } from "react";
import "./Banner.css";
import profile from "../../images/azizul.jpg";
import Typical from "react-typical";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faGithub,
  faLinkedinIn,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import MessageModal from "../MessageModal/MessageModal";
import Particles from "react-particles-js";

function Banner() {
  const [modalIsOpen, setIsOpen] = useState(false);
  console.log(setIsOpen);
  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <section>
      <div id='home-id'>
        <div id='home-bg' className='text-center'>
          <Particles
            params={{
              particles: {
                number: {
                  value: 160,
                  density: {
                    enable: false,
                  },
                },
                size: {
                  value: 10,
                  random: true,
                  anim: {
                    speed: 4,
                    size_min: 0.3,
                  },
                },
                line_linked: {
                  enable: false,
                },
                move: {
                  random: true,
                  speed: 1,
                  direction: "random",
                  out_mode: "out",
                },
              },
              interactivity: {
                events: {
                  onhover: {
                    enable: true,
                    mode: "bubble",
                  },
                  onclick: {
                    enable: true,
                    mode: "repulse",
                  },
                },
                modes: {
                  bubble: {
                    distance: 250,
                    duration: 2,
                    size: 0,
                    opacity: 0,
                  },
                  repulse: {
                    distance: 400,
                    duration: 4,
                  },
                },
              },
            }}
          />
          <div className='container banner'>
            <img className='img-fluid mt-5' src={profile} alt='' />
            <h1>Azizul Haque</h1>
            <h5 className='text-white'>
              Hi, I am{" "}
              <Typical
                steps={[
                  "A Web Developer",
                  2000,
                  "A Programmer",
                  2000,
                  "A Designer",
                  2000,
                ]}
                loop={Infinity}
                wrapper='span'
              />
            </h5>
            <div>
              <a
                href='https://www.facebook.com/azizul.haque.789'
                target='_blank'
              >
                <FontAwesomeIcon className='social-icon' icon={faFacebook} />
              </a>
              <a href='https://twitter.com/azizul__haque' target='_blank'>
                <FontAwesomeIcon className='social-icon' icon={faTwitter} />
              </a>
              <a
                href='https://www.linkedin.com/in/azizul--haque/'
                target='_blank'
              >
                <FontAwesomeIcon className='social-icon' icon={faLinkedinIn} />
              </a>
              <a href='https://github.com/azizul016' target='_blank'>
                <FontAwesomeIcon className='social-icon' icon={faGithub} />
              </a>
            </div>
            <div className='pt-4 d-flex justify-content-center'>
              <div>
                <button
                  style={{ height: "45px", width: "146px" }}
                  onClick={openModal}
                  className='btn btn-outline-danger button'
                >
                  Send Massage
                </button>
                <MessageModal
                  modalIsOpen={modalIsOpen}
                  closeModal={closeModal}
                />
              </div>
              <div>
                <a href='https://drive.google.com/u/0/uc?id=1REElGOWHwI_-dL1Eqgryq3Gb-UBN5Etk&export=download'>
                  <button className='btn btn-danger resume-btn'>
                    <strong>Download Resume</strong>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
